export default {

  methods: {

    set_LocalValues(){

      this.rawData = JSON.parse(JSON.stringify(this.DataItems[0]))
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.table    = json.table
      this.columns  = json.columns
      this.keys     = json.keys
      this.filters  = json.filters
      this.sundries = json.sundries

      let x_ = 0
      this.columns.forEach(d=> {
        d.sx = x_
        d.mx = x_ + (d.width/2)
        
        if(d.align == 'start') d.tx = x_ + d.width +5
        if(d.align == 'middle') d.tx = x_ + (d.width/2)
        if(d.align == 'end') d.tx = x_ + d.width -5

        x_ = x_ + d.width + this.table.box.padding
      })

    

    },

  }
}